import React, {useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
import { form1 } from "../Service/Api";
import { getHeader } from "../config";
const GuestBook = () => {  
    const [formData, setFormData] = useState({
        name: "",  
        webAddress: "",
        email: "",
        profession: "",
        rate: "",
        howKnow:"",
        message:"",
    });

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        // Clear the error for the current field
        setErrors({
            ...errors,
            [e.target.name]: ""
        });
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name) newErrors.name = "Name is required";
        if (!formData.email) newErrors.email = "Email is required";
        if (!formData.profession) newErrors.profession = " Profession is required";
        if (!formData.webAddress) newErrors.webAddress =  "webAddress is required ";
        if (!formData.message) newErrors.message = " This Field is required";
        if (!formData.howKnow) newErrors.howKnow = " This Field is required";
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return; // Stop submission if validation fails
        } 
        const type = 'abc'; 
        console.log('Submitting form with type:', type); // Add this line for debugging
        try {
            const { header } = getHeader();
            const response = await form1(formData, header, type); 
            console.log('Form submitted successfully', response);
            document.querySelector(".primary-alert").innerHTML = "<p>Your Form Submitted Successfully.</p>";
            setFormData({
                name: "",  
                webAddress: "",
                email: "",
                profession: "",
                rate: "",
                howKnow:"",
                message:"",
            }); // Reset form data
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };  
  useEffect(() => {
    document.title = 'Guest Book - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>Contact Us</li>
                    <li>Guest Book</li>
                </ul>
            </div> 
            <section className="innerbody">
                <div className="container"> 
                    <div className="row">
                          <div className="col-lg-12">
                          <form onSubmit={handleSubmit}>
                          <div className="formdiv guestform">
                              <div className="form-group">
                                  <label className="form-label">Name <span>*</span></label>
                                  <input
                                      type="text"
                                      className="form-control"
                                      name="name"
                                      value={formData.name}
                                      onChange={handleChange}
                                  />
                                 {errors.name && <div className="error">{errors.name}</div>}
                              </div>
                              <div className="form-group">
                                  <label className="form-label">Web Address (if any) <span>*</span></label>
                                  <input
                                      type="text"
                                      className="form-control"
                                      name="webAddress"
                                      value={formData.webAddress}
                                      onChange={handleChange}
                                  />
                                   {errors.webAddress && <div className="error">{errors.webAddress}</div>}
                              </div>
                              <div className="form-group">
                                  <label className="form-label">Email <span>*</span></label>
                                  <input
                                      type="text"
                                      name="email"
                                      className="form-control"
                                      value={formData.email}
                                      onChange={handleChange}
                                  />
                                   {errors.email && <div className="error">{errors.email}</div>}
                              </div>
                              <div className="form-group">
                                  <label className="form-label">Your Profession <span>*</span></label>
                                  <input
                                      type="text"
                                      className="form-control"
                                      name="profession"
                                      value={formData.profession}
                                      onChange={handleChange}
                                  />
                                    {errors.profession && <div className="error">{errors.profession}</div>}
                              </div>
                              <div className="form-group">
                                  <label className="form-label"> Please Rate us</label>
                                  <select
                                      className="form-control"
                                      name="rate"
                                      value={formData.rate}
                                      onChange={handleChange}
                                  >
                                      <option value="">-Please Select-</option>
                                      <option value="Excellent">Excellent</option>
                                      <option value="Very Good">Very Good</option>
                                      <option value="Good">Good</option>
                                      <option value="Average">Average</option>
                                      <option value="Poor">Poor</option>
                                  </select>
                                   
                              </div>
                              <div className="form-group">
                                  <label className="form-label">How do you come to know about us? <span>*</span></label>
                                  <select
                                      className="form-control"
                                      name="howKnow"
                                      value={formData.howKnow}
                                      onChange={handleChange}
                                  >
                                      <option value="">-Please Select-</option>
                                      <option value="Referred by a friend">Referred by a friend</option>
                                      <option value="I am a student">I am a student</option>
                                      <option value="I am a parent">I am a parent</option>
                                      <option value="I am an ex-student">I am an ex-student</option>
                                      <option value="Through search engines">Through search engines</option>
                                  </select>
                                   {errors.howKnow && <div className="error">{errors.howKnow}</div>}
                              </div>
                              <div className="form-group textarea">
                                  <label className="form-label">Comments that can help us to make this site better: <span>*</span></label>
                                  <textarea
                                      className="form-control"
                                      name="message"
                                      value={formData.message}
                                      onChange={handleChange}
                                  ></textarea>
                                   {errors.message && <div className="error">{errors.message}</div>}
                              </div>
                          </div>
                          <input type="submit" value="Submit" />
                          <div className="row"> 
                          <div className="col-lg-12 col-md-12">
                              <div className='primary-alert'></div>
                          </div>
                      </div>
                      </form>
                          </div>
                    </div>
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default GuestBook;
